import React, { useState, useContext } from 'react';

const initialContext = {
  projectIdContext: '',
  rcVersionContext: null,
  setProjectIdContext: () => null,
  setRcVersionContext: () => null,
};

export interface ProjectContextProps {
  projectIdContext: string;
  rcVersionContext: string | null;
  setProjectIdContext: (val: string) => void;
  setRcVersionContext: (val: string) => void;
}

export const ProjectContext = React.createContext<ProjectContextProps>(initialContext);

export const useProjectContext = () => useContext(ProjectContext);

export const ProjectContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [projectIdContext, setProjectIdContext] = useState<string>(initialContext.projectIdContext);
  const [rcVersionContext, setRcVersionContext] = useState<string | null>(initialContext.rcVersionContext);

  return (
    <ProjectContext.Provider
      value={{
        projectIdContext,
        setProjectIdContext,
        rcVersionContext,
        setRcVersionContext,
      }}
    >
      {children}
    </ProjectContext.Provider>
  );
};
